// import matt_howard from '../../../assets/img/partnerPortal/welcomeAccenture/matt-howard.jpg';
// import laurent_gaudy from '../../../assets/img/partnerPortal/welcomeAccenture/laurent_gaudy.jpg';
// import wilfred_de_jong from '../../../assets/img/partnerPortal/welcomeAccenture/wilfred_de_jong.jpg';
// import alejandro_musgrove from '../../../assets/img/partnerPortal/welcomePage/alejandro-musgrove.jpg';
// import alex_lim from '../../../assets/img/partnerPortal/welcomePage/alex-lim.png';
// import scott_wintermute from '../../../assets/img/partnerPortal/welcomeAccenture/scott-wintermute.jpg';
// import cole_england from '../../../assets/img/partnerPortal/welcomeAccenture/cole-england.jpg';
// import mourad_attari from '../../../assets/img/partnerPortal/welcomeAccenture/mourad_attari.png';
// import jeffrey_de_haan from '../../../assets/img/partnerPortal/welcomeAccenture/jeffrey-de-haan.png';
import custom from "../../../assets/img/partnerPortal/welcomePage/innovate.png";
import gartner_banner from "../../../assets/img/partnerPortal/welcomePage/gartner_banner.png";
import perform_banner from "../../../assets/img/partnerPortal/welcomePage/perform_banner.jpg";

import News from "../../../models/common/News";
import Contact from "../../../models/common/Contact";
import Banner from "../../../models/common/Banner";

// BANNER
export const TITLE = (
  <div>
    Welcome to your<br></br>Partner Portal
  </div>
);
export const ABOVE_TITLE = "PREMIER PARTNER";
export const BUTTON_NAME = "Register a deal";
export const BUTTON_LINK = "https://partners.dynatrace.com/#/page/sales";
// --

// BANNERS
const banner0: Banner = new Banner(
  "https://www.dynatrace.com/gartner-magic-quadrant-for-observability-platforms/?utm_med[…]race&utm_campaign=partner&utm_content=portal&utm_term=q2fy25",
  "_parent",
  "100%",
  gartner_banner
);
const banner1: Banner = new Banner(
  "https://partners.dynatrace.com/#/page/perform-2025-on-demand",
  "_parent",
  "100%",
  perform_banner
);
const banner2: Banner = new Banner(
  "https://www.dynatrace.com/innovate/?utm_medium=partner&utm_source=dynatrace&utm_campaign=innovate&utm_content=partner-portal&utm_term=25",
  "_parent",
  "100%",
  custom
);
export const ALL_BANNERS: Array<Banner> = new Array<Banner>(banner0, banner1);

// CONTACTS

const dynaContact1: Contact = new Contact(
  "Eric Sherman",
  "Dynatrace General Manager",
  "eric.sherman@dynatrace.com",
  "Tel. +1 781 530 1320"
);
const dynaContact2: Contact = new Contact(
  "Jill Head",
  "Global Strategic Partner Marketing",
  "jill.head@dynatrace.com",
  "Tel. +1 720-371-1357 "
);
const dynaContact3: Contact = new Contact(
  "Russel Wilkinson",
  "Global Partner Cloud Evangelists (SE)",
  "russel.wilkinson@dynatrace.com"
);
const dynaContact4: Contact = new Contact(
  "Matt Howard",
  "GTM Lead-NORAM",
  "matt.howard@dynatrace.com",
  "Tel. +1 630-886-9981"
);
const dynaContact5: Contact = new Contact(
  "Marek Drozdz",
  "GTM Lead-EMEA",
  "Marek.Drozdz@dynatrace.com",
  "Tel. +48 602 516 516"
);
const dynaContact6: Contact = new Contact(
  "Alejandro Musgrove",
  "LATAM Partner Sales Leader",
  "alejandro.musgrove@dynatrace.com",
  "Tel. +1 954-684-3117"
);
const dynaContact7: Contact = new Contact(
  "Alex Lim",
  "APAC Partner Sales Leader",
  "alex.lim@dynatrace.com",
  "Tel. +65 833-959-68"
);
export const ALL_DYNA_CONTACT_LIST: Array<Contact> = new Array<Contact>(
  dynaContact1,
  dynaContact2,
  dynaContact3,
  dynaContact4,
  dynaContact5,
  dynaContact6,
  dynaContact7
);

/*const partnerContact3: Contact = new Contact("Mourad Attari", "Senior Manager, Technology Architecture", "mourad.attari@accenture.com", "");
const partnerContact4: Contact = new Contact("Scott Wintermute", "Managing Director", "scott.wintermute@accenture.com", "Tel.+44 777-197-5265");
const partnerContact1: Contact = new Contact("Cole England", "Associate Director", "cole.england@accenture.com", "Tel. +415-732-9777");
const partnerContact2: Contact = new Contact("Jeffrey de Haan", "Observability Lead", "Jeffrey.de.haan@accenture.com", "");
export const ALL_PARTNER_CONTACT_LIST: Array<Contact> = new Array<Contact>(partnerContact1, partnerContact2, partnerContact3, partnerContact4);*/
// --

// NEWS AND EVENTS
const news33: News = new News(
  "Perform and Innovate Sponsor Prospectus FY26",
  "https://partners.dynatrace.com/content/8a99822b95b0e7e80195b4734ee018f8",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news32: News = new News(
  "Watch Perform on-demand​",
  "https://www.dynatrace.com/perform/",
  true,
  true,
  true,
  undefined,
  "Watch now"
);
const news31: News = new News(
  "Dynatrace Introduces Observability for Developers​",
  "https://www.dynatrace.com/news/press-release/dynatrace-introduces-observability-for-developers/",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news30: News = new News(
  "Dynatrace Partners with Visa Cash App Racing Bulls (VCARB) Formula One™ Team​",
  "https://www.dynatrace.com/news/press-release/dynatrace-partners-with-visa-cash-app-racing-bulls-vcarb-formula-one-team-as-official-observability-performance-analytics-technology-partner/",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news29: News = new News(
  "Streaming event: Dynatrace & the Power of Possible​",
  " https://webinars.techstronglearning.com/dynatrace-and-the-power-of-possible?utm_medium=partner&utm_source=dynatrace&utm_campaign=virtual-event&utm_content=portal&utm_term=q3fy25",
  false,
  true,
  true
);
const news28: News = new News(
  "Partners lead with Dynatrace SaaS​",
  "https://partners.dynatrace.com/#/collateral/8a9983ce90d6f9a50190f221a5f121bd",
  false,
  true,
  true
);
const news26: News = new News(
  "Dynatrace named a Leader in the 2024 Gartner® Magic Quadrant™ for Observability Platforms​",
  "https://www.dynatrace.com/gartner-magic-quadrant-for-observability-platforms/?utm_medium=partner&utm_source=dynatrace&utm_campaign=partner&utm_content=portal&utm_term=q2fy25",
  false,
  false,
  false
);

const event17: News = new News(
  "Learn how to master the Dynatrace Partner Deliver Toolkit",
  "https://info.dynatrace.com/noram-all-wb-partner-delivery-toolkit-26404-od-fulfillment.html?utm_medium=partner&utm_source=dynatrace&utm_campaign=portal&utm_content=all-active-partners&utm_term=none&mkt_tok=MzUyLU5WTy01NjIAAAGY5uZvOiRelPaOTN3vSicEXtUu1G4fcCPHd0QPVHj8YbfjrjGTV3GCMjiUFZaQKdEbZlgiU3boBximTOnaZiQb",
  true,
  true,
  true,
  "On-Demand Webinar",
  "Watch now"
);

const event13: News = new News(
  "Key highlights from Perform 2025",
  "https://partners.dynatrace.com/#/page/perform-2025-on-demand",
  true,
  true,
  true,
  "On-Demand Webinar",
  "Watch now"
);

export const ALL_EVENTS_LIST: Array<News> = new Array<News>(
  news33,
  news32,
  news31,
  news30,
  news29,
  news28,
  news26,
  event17,
  event13
);

// VIDEOS

const video4: News = new News(
  "20 March 24: Accenture Cocktails in the Cloud event: Avanade, Azure and Dynatrace",
  "https://partners.dynatrace.com/#/page/accenture-cocktails-in-the-cloud",
  false,
  true,
  true,
  "",
  "watch the video"
);
const video2: News = new News(
  "6 December 22: Accenture Observability Hub Plays & Offerings",
  "https://partners.dynatrace.com/#/page/accenture-obs-hub-plays",
  false,
  true,
  true,
  "",
  "watch the video"
);
const video3: News = new News(
  "15 November 23: Accenture Cocktails in the Cloud event: Infrastructure Observability ",
  "https://partners.dynatrace.com/#/page/accenture-infra-obs",
  false,
  true,
  true,
  "",
  "watch the video"
);
const video1: News = new News(
  "2 June 22: Accenture Observability Hub Launch",
  "https://partners.dynatrace.com/#/page/accenture-obs-hub-launch",
  false,
  true,
  true,
  "",
  "watch the video"
);
export const ACCENTURE_VIDEO_PAGES: Array<News> = new Array<News>(
  video4,
  video3,
  video2,
  video1
);
